

import React from 'react'

const Button = (props) =>{
    return (
        <button type="submit" className="bg-primary w-32 h-10 text-white rounded">{props.name}</button>

    )


}

export default Button
